import { Button } from '@/components/ui/button';
import { useAuthStore } from '@/stores/auth.store';

interface CallingActionProps {
  capabilities: Record<string, boolean> | undefined;
  onEnable: () => void;
  disabled: boolean;
}

/**
 * "Enable calling" for a number row. Hidden once calling is on, or for non-admins
 * (enabling calling is an admin-only action). The hint only shows when calling is
 * known to be off; numbers added outside the platform have no flag.
 */
export const CallingAction = ({ capabilities, onEnable, disabled }: CallingActionProps) => {
  const isAdmin = useAuthStore((state) => state.user?.role === 'admin');
  const calling = capabilities?.calling;
  if (!isAdmin || calling === true) return null;

  return (
    <>
      {calling === false && (
        <span className="self-center text-xs text-amber-600">Calling not enabled</span>
      )}
      <Button size="sm" variant="ghost" onClick={onEnable} disabled={disabled}>
        Enable calling
      </Button>
    </>
  );
};
